module.exports = __webpack_public_path__ + "c38b90c94ec027384c14d110ca9a9310.MP3";